<template>
  <el-table
      :data="auditLogs"
      border
      style="width: 100%"
  >
    <el-table-column prop="createTime" label="审核时间"  ></el-table-column>
    <el-table-column prop="operatorName" label="审核人"  ></el-table-column>
    <el-table-column prop="status" label="审核结果"  >
      <template #default="scope">
        {{ formatStatus(scope.row) }}
      </template>
    </el-table-column>


    <!-- 驳回详情列 -->
    <el-table-column label="驳回原因" min-width="120" >
      <template slot-scope="{ row, $index }">
        <div v-if=" row.rejectedFiles && row.rejectedFiles.length"    class="reject-detail">
          <!-- 支出明细项 -->
          <div
              v-for="(expense, eIdx) in getVisibleExpenses(row.rejectedFiles, $index)"
              :key="eIdx"
              class="expense-block"
          >
            <div class="expense-header">
              {{ expense.detailName }}（{{ expense.folderName }}）
            </div>
            <div class="file-items">
              <!-- 文件列表 -->
              <div
                  v-for="(file, fIdx) in getVisibleFiles(expense.files, $index, eIdx)"
                  :key="fIdx"
                  class="file-item"
              >
                <span class="file-name">{{ file.fileName }}</span>
                <span class="reject-reason">（{{ file.rejectReason }}）</span>
              </div>
            </div>

            <!-- 展开/收起文件按钮 -->
            <div v-if="expense.files.length > FILE_SHOW_LIMIT" class="toggle-btn">
              <el-link
                  type="info"
                  :underline="false"
                  @click="toggleFile($index, eIdx)"
                  style="font-size: 12px;"
              >
                {{ isFileExpanded($index, eIdx) ? '收起文件' : `查看全部 (${expense.files.length} 项)` }}
              </el-link>
            </div>
          </div>

          <!-- 展开/收起支出明细按钮 -->
          <div v-if="row.rejectedFiles.length > EXPENSE_SHOW_LIMIT" class="toggle-expense">
            <el-link
                type="info"
                :underline="false"
                @click="toggleExpense($index)"
                style="font-size: 12px;"
            >
              {{ isExpenseExpanded($index) ? '收起所有支出明细' : `展开全部 (${row.rejectedFiles.length} 项)` }}
            </el-link>
          </div>
        </div>
        <span v-else > {{row.remark}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'AuditLogTable',
  props: {
    // 审核日志列表，每项包含 rejectedFiles 字段（从后端 JSON 反序列化后的对象数组）
    auditLogs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      EXPENSE_SHOW_LIMIT: 2, // 默认显示前2个支出明细
      FILE_SHOW_LIMIT: 3,    // 每个明细默认显示前3个文件

      // 折叠状态管理
      expandedExpenses: {},   // { rowIndex: true }
      expandedFiles: {}       // { "rowIndex-eIdx": true }
    };
  },
  methods: {



    formatStatus(item) {
      const status = item.status
      const statusMap = {
        WAIT:'未提交',
        AI_REVIEW_SUCCESS:'官员审核中',
        OFFICIAL_EXAMINE: '官员审核中',
        REJECTED: '财务驳回',
        SUBMIT: '财务审核中',
        ERROR: '审核驳回',
        FINISH: '已打款',
        SUCCESS: '财务审核通过'
      };
      if (item.operatorId == '0' && status == 'ERROR') {
        return "财务审核驳回"
      }
      return statusMap[status] || '未知状态';
    },



    // --- 支出明细折叠 ---
    isExpenseExpanded(rowIndex) {
      return !!this.expandedExpenses[rowIndex];
    },
    toggleExpense(rowIndex) {
      this.$set(this.expandedExpenses, rowIndex, !this.expandedExpenses[rowIndex]);
    },
    getVisibleExpenses(items, rowIndex) {
      return this.isExpenseExpanded(rowIndex)
          ? items
          : items.slice(0, this.EXPENSE_SHOW_LIMIT);
    },

    // --- 文件折叠 ---
    getFileKey(rowIndex, eIdx) {
      return `${rowIndex}-${eIdx}`;
    },
    isFileExpanded(rowIndex, eIdx) {
      return !!this.expandedFiles[this.getFileKey(rowIndex, eIdx)];
    },
    toggleFile(rowIndex, eIdx) {
      const key = this.getFileKey(rowIndex, eIdx);
      this.$set(this.expandedFiles, key, !this.expandedFiles[key]);
    },
    getVisibleFiles(files, rowIndex, eIdx) {
      return this.isFileExpanded(rowIndex, eIdx)
          ? files
          : files.slice(0, this.FILE_SHOW_LIMIT);
    }
  }
};
</script>

<style scoped>
.reject-detail {
  font-size: 13px;
  line-height: 1.6;
}

.expense-block {
  margin-bottom: 12px;
}

.expense-block:last-child {
  margin-bottom: 0;
}

.expense-header {
  font-weight: 600;
  color: #303133;
  font-size: 13px;
  margin-bottom: 6px;
}

.file-item {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 4px;
  padding-left: 16px; /* 👈 添加这一行，实现缩进 */
}

.file-name {
  color: #409eff;
  font-size: 13px;
  /* 不是链接，只是强调色 */
}

.reject-reason {
  color: #e63946;
  font-size: 12px;
}

.toggle-btn,
.toggle-expense {
  margin-top: 6px;
}
</style>
